<template>
  <section
    v-show="isVisible"
    class="order-flow__item collapsible"
    :class="[
      {'is-open': open},
      {'is-done': done},
      modifierClass
      ]">
    <div v-if="headline" class="order-flow__item__header">
      <h2 class="order-flow__item__header__headline" @click="doClickHeadline" :class="{'cursor-pointer':clickableHeadline}">
        <span class="order-flow__item__header__headline__number">{{number}}</span>
        {{headline}}
      </h2>
    </div>
    <div :class="{'collapsible-content': !open}">
      <div class="order-flow__item__form">
        <slot></slot>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'OrderFlow',
  props: {
    open: {
      type: Boolean,
      default: true,
      twoWay: true
    },
    done: {
      type: Boolean,
      default: false,
      twoWay: true
    },
    show: {
      type: Boolean,
      default: true,
      twoWay: true
    },
    headline: {
      type: String,
      default: null
    },
    clickableHeadline: {
      type: Boolean
    },
    modifier: {
      type: String,
      default: '' // ( [ grey || grey-medium ], extra-padding ]
    },
    number: {
      type: Number,
      default: 1
    }
  },
  data: function () {
    return {
      orderFlowItem: 'order-flow__item--',
      isVisible: this.show,
      isOpen: this.open,
      isDone: this.done
    }
  },
  computed: {
    modifierClass () {
      if (this.modifier.length) {
        return this.modifier.split(' ').map(m => this.orderFlowItem + m).join(' ')
      } else {
        return ''
      }
    }
  },
  methods: {
    doClickHeadline () {
      if (this.clickableHeadline) {
        this.$emit('goto')
      }
    },
    doClose () {
    }
  }
}
</script>

<style scope>
.collapsible-content--open {
  display:block
}
.cursor-pointer {
  cursor:pointer
}
</style>



// WEBPACK FOOTER //
// src/components/common/OrderFlow.vue